<template>
    <div id="page-news-details">
      <news-form
          v-model="model"
          ref="form"
          :loading="loading"
          card-title="Create News"
      />
  
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button
              @click="$router.push({ name: 'content-management.news.list' })"
              class="my-4"
            >
              Cancel
            </vs-button>
          </div>
        </div>
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button
              :disabled="loading"
              @click="create"
              class="my-4"
              color="light"
            >
              Create
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import NewsForm from "@/views/pages/content-management/news/Form";
  import NotificationMixin from "@/components/mixins/NotificationMixin";
  import SaveModelMixin from '@/components/mixins/SaveModelMixin';
  import moment from 'moment';
  
  export default {
    name: "NewsCreate",
    components: {
      NewsForm
    },
    mixins: [NotificationMixin, SaveModelMixin],
    data() {
      return {
        model: {},
        loading: false,
      };
    },
    created() {
      this.setDefaultStartDate();
    },
    methods: {
      getParams() {
        const params = {
          ...this.model
        }
  
        const references = [
          'SalesCountryType_FK',
        ]
        
        const dates = [
          'NewsValidFrom',
          'NewsValidTo',
        ]

        references.forEach((ref) => params[ref] = this.getReferenceId(ref))
        this.setDates(dates, params);

        if (params.companies && params.companies.length) {
          const multiReferences = [
            {
              array: 'companies',
              key: 'Company_FK'
            },
          ];

          this.setMultiReferences(multiReferences, params);
        }
  
        return params;
      },
      getReferenceId(fieldName) {
        if (!this.model[fieldName]) {
          return null;
        }
  
        return this.model[fieldName].id || null;
      },
      async create() {
        if (!this.$refs.form.validate()) {
          this.notifyError('Not all required fields have been provided');
          return false;
        }
  
        // this.loading = true;
        const params = this.getParams();

        if (!params.IsNewsForAll
          && (!params.applications || !Object.keys(params.applications).length)
        ) {
          this.notifyError('Please select at least one Application');
          return false;
        }

        try {
          const {data} = await this.$api.contentManagementNews.create(params);
          this.notifySuccess('News created');
          this.$router.back();
        } catch (e) {
          this.notifyError('News failed to be created');
          console.error(e)
        } finally {
        }
      },
      setDefaultStartDate() {
        this.model.NewsValidFrom = moment().format('YYYY-MM-DD 00:00:00');
      },
    },
  };
  </script>
  
  <style scoped>
  
  </style>
  